import client from "../axios";
import {GET_BANNER, POST_BANNER, PUT_BANNER, DELETE_BANNER} from 'api/endpoint';

//리스트
export const getBannerAPI = () => {
    return client.get(GET_BANNER);
}

//등록
export const postBannerAPI = (params) => {
  return client.post(POST_BANNER, params)
}


//수정
export const putBannerAPI = (params) => {
  return client.put(PUT_BANNER, params);
}

//삭제
export const deleteBannerAPI = (data) => {
  return client.delete(DELETE_BANNER, {data});
};

